var app = app || {};
(function ($) {
    $.cachedGet = function (url, options) {
        options = options || {};

        if (options.cache) {
            // it is assumed that a timestamp is already included in the url and caching is being handled manually
        } else {
            // if Development environment, don't cache by generating new timestamp each time.
            const timestamp = app.session.application.environment && app.session.application.environment.toLowerCase().indexOf("development") !== -1
                ? app.utils.dateTime.getTicks(new Date())
                : app.utils.dateTime.getTicks(new Date(app.session.application.releaseDate));

            options.data = {
                v: timestamp
            };
        }

        options.dataType = options.dataType || "script";

        // Allow user to set any option except for cache, and url
        options = $.extend(options, {
            cache: true,
            url: url
        });

        // Use $.ajax() since it is more flexible than $.getScript
        // Return the jqXHR object so we can chain callbacks
        return $.ajax(options);
    };

    var appLocalizationSource = abp.localization.getSource($("body").data("localization-source-name"));
    app.localize = function () {
        return appLocalizationSource.apply(this, arguments);
    };

    app.downloadTempFile = function (file) {
        location.href = abp.appPath + "File/DownloadTempFile?fileType=" + file.fileType + "&fileToken=" + file.fileToken + "&fileName=" + file.fileName;
    };

    app.createDateRangePickerOptions = function (extraOptions) {
        extraOptions = extraOptions ||
        {
            allowFutureDate: false
        };

        const options = {
            locale: {
                format: "L",
                applyLabel: app.localize("Apply"),
                cancelLabel: app.localize("Cancel"),
                customRangeLabel: app.localize("CustomRange")
            },
            min: window.moment("2015-05-01"),
            minDate: window.moment("2015-05-01"),
            opens: "left",
            ranges: {}
        };

        if (!extraOptions.allowFutureDate) {
            options.max = window.moment();
            options.maxDate = window.moment();
        }

        options.ranges[app.localize("Today")] = [window.moment().startOf("day"), window.moment().endOf("day")];
        options.ranges[app.localize("Yesterday")] = [window.moment().subtract(1, "days").startOf("day"), window.moment().subtract(1, "days").endOf("day")];
        options.ranges[app.localize("Last7Days")] = [window.moment().subtract(6, "days").startOf("day"), window.moment().endOf("day")];
        options.ranges[app.localize("Last30Days")] = [window.moment().subtract(29, "days").startOf("day"), window.moment().endOf("day")];
        options.ranges[app.localize("ThisMonth")] = [window.moment().startOf("month"), window.moment().endOf("month")];
        options.ranges[app.localize("LastMonth")] = [window.moment().subtract(1, "month").startOf("month"), window.moment().subtract(1, "month").endOf("month")];

        return options;
    };

    app.getUserProfilePicturePath = function (profilePictureId) {
        return profilePictureId ?
            (abp.appPath + "Profile/GetProfilePicture?v=" + profilePictureId) :
            (abp.appPath + "Profile/GetDefaultProfilePicture");
    };

    app.notification = {
        getTextBySeverity: function (severity) {
            switch (severity) {
                case abp.notifications.severity.SUCCESS:
                    return app.localize("Success");

                case abp.notifications.severity.WARN:
                    return app.localize("Warning");

                case abp.notifications.severity.ERROR:
                    return app.localize("Error");

                case abp.notifications.severity.FATAL:
                    return app.localize("Fatal");

                case abp.notifications.severity.INFO:
                default:
                    return app.localize("Info");
            }
        },
        getUiIconBySeverity: function (severity) {
            switch (severity) {
                case abp.notifications.severity.SUCCESS:
                    return "fas fa-check-circle";

                case abp.notifications.severity.WARN:
                    return "fas fa-exclamation-triangle";

                case abp.notifications.severity.ERROR:
                    return "fas fa-exclamation-circle";

                case abp.notifications.severity.FATAL:
                    return "fas fa-bomb";

                case abp.notifications.severity.INFO:
                default:
                    return "fas fa-info-circle";
            }
        },
        getIconFontClassBySeverity: function (severity) {
            switch (severity) {
                case abp.notifications.severity.SUCCESS:
                    return " text-success";

                case abp.notifications.severity.WARN:
                    return " text-warning";

                case abp.notifications.severity.ERROR:
                    return " text-danger";

                case abp.notifications.severity.FATAL:
                    return " text-danger";

                case abp.notifications.severity.INFO:
                default:
                    return " text-info";
            }
        }
    };

    app.changeNotifyPosition = function (positionClass) {
        if (!window.toastr) {
            return;
        }

        window.toastr.clear();
        window.toastr.options.positionClass = positionClass;
    };

    app.waitUntilElementIsReady = function (selector, callback, checkPeriod) {
        if (!$) {
            return;
        }

        var elementCount = selector.split(",").length;

        if (!checkPeriod) {
            checkPeriod = 100;
        }

        var checkExist = setInterval(function () {
            if ($(selector).length >= elementCount) {
                clearInterval(checkExist);
                callback();
            }
        }, checkPeriod);
    };

    app.calculateTimeDifference = function (fromTime, toTime, period) {
        if (!window.moment) {
            return null;
        }

        const from = window.moment(fromTime);
        const to = window.moment(toTime);
        return to.diff(from, period);
    };

    app.guid = function () {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }

        return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
    };

    app.isRTL = function () {
        return document.documentElement.getAttribute("dir") === "rtl" || document.documentElement.getAttribute("direction") === "rtl";
    };

    let preventFocusFirstElement = false;
    let focusFirstElementId;
    app.focusFirstElement = function (container = "body", elementToFocus = null) {
        if (preventFocusFirstElement) {
            preventFocusFirstElement = false;
        } else {
            focusFirstElementId = setTimeout(function () {
                if (elementToFocus) {
                    const $elementToFocus = container ? $(elementToFocus, container) : $(elementToFocus);

                    if ($elementToFocus.length > 0) {
                        if ($elementToFocus.hasClass("selectized")) {
                            $elementToFocus.get(0).selectize.focus();
                        } else {
                            $elementToFocus.focus().select();
                        }
                    }
                } else {
                    $(container).find('input:not(:hidden):not([type="hidden"]):not([disabled]):not([readonly]), textarea:not(:hidden), select:not(:hidden)').first().focus().select();
                }
            }, 500);
        }
    };
    app.cancelFocusFirstElement = function () {
        if (focusFirstElementId) {
            clearTimeout(focusFirstElementId);
            focusFirstElementId = null;
        }
    };
    app.preventFocusFirstElement = function (flag = true) {
        preventFocusFirstElement = flag;
    };

    app.resetForm = function (form) {
        $('.btn-group-toggle input[type="radio"]:first', $(form)).prop("checked", true);
        $(".btn-group-toggle label.btn", $(form)).removeClass("active").first().addClass("active");

        $('input:not([type="hidden"])', $(form)).val("");
        $("select", $(form)).val("");
    };

    app.dataTables = {
        init: function (container = "body") {

        },
        registerChangeTracker: function (api, changeTracker, changeTrackerItemId) {
            const currentValuesCallback = function () {
                const currentValues = [];

                api.rows("tr[id]").every(function (rowIdx, tableLoop, rowLoop) {
                    const data = this.data();

                    if (data.changeStatus != undefined && data.changeStatus != app.enums.changeStatus.unchanged && (parseInt(data.id, 10) > 0 || data.changeStatus != app.enums.changeStatus.deleted)) {
                        currentValues.push(data.id);
                    }
                });

                return currentValues;
            };
            const originalValues = currentValuesCallback();

            changeTracker.add(
                changeTrackerItemId,
                currentValuesCallback,
                originalValues,
                (currentValuesCallback, originalValues) => {
                    const currentValues = currentValuesCallback();

                    if (currentValues.length !== originalValues.length) {
                        return true;
                    }

                    return !_.isEqual(currentValues.sort(), originalValues.sort()); // comparing the currentValues and originalValues arrays regardless of the order.
                });
        },
        destroy: function (container = "body") {
            const $container = $(container);

            $container.find(".dataTables_wrapper").each(function () {
                const $modalTableWrapper = $(this);

                const $modalTable = $("table.dataTable", $modalTableWrapper);
                if ($.fn.dataTable.isDataTable($modalTable)) {
                    const api = $modalTable.DataTable();
                    /*
                    if (container !== "body") {
                        // if FixedHeader is enabled and when the modal is being scrolled down until the floating FixedHeader is visible,
                        // destroying the DataTable would for some reasons cause an error.
                        // Therefore, scroll the modal to the top before destroying the DataTable.
                        $container.parent().find(".modal, .modal-body").scrollTop(0);
                    }
                    */
                    api.destroy(true);
                }
            });
        },
        adjustColumns: function (container = "body") {
            if (!$.fn.dataTable) {
                return;
            }

            const visibleTables = $.fn.dataTable.tables({ visible: true });

            const $tableWrappers = $(container).hasClass("dataTables_wrapper") ? $(container) : $(".dataTables_wrapper", container);
            $tableWrappers.each(function () {
                const $tableWrapper = $(this);

                $.each(visibleTables, function () {
                    const $visibleTable = $(this);
                    const $visibleTableWrapper = $visibleTable.closest(".dataTables_wrapper");

                    if ($tableWrapper.get(0) === $visibleTableWrapper.get(0)) {
                        // need to set a slight delay for the datatable to be fully shown and not hidden anymore.
                        // styles such as width, height, etc is not accessible when an element is hidden.
                        setTimeout(function () {
                            if ($.fn.dataTable.isDataTable($visibleTable)) {
                                $visibleTable.DataTable().columns.adjust();
                            }
                        }, 100);

                        return false;
                    }
                });
            });
        },
        resizeActionButtonsContainer: function (container = "body") {
            const visibleTables = $.fn.dataTable.tables({ visible: true });

            const $tableWrappers = $(".dataTables_wrapper", container);
            $tableWrappers.each(function () {
                const $tableWrapper = $(this);

                $.each(visibleTables, function () {
                    const $visibleTable = $(this);
                    const $visibleTableWrapper = $visibleTable.closest(".dataTables_wrapper");

                    if ($tableWrapper.get(0) === $visibleTableWrapper.get(0)) {
                        // need to set a slight delay for the datatable to be fully shown and not hidden anymore.
                        // styles such as width, height, etc is not accessible when an element is hidden.
                        setTimeout(function () {
                            if ($.fn.dataTable.isDataTable($visibleTable)) {
                                $(".datatable-action-buttons-container-placeholder", $visibleTable).each(function () {
                                    if ($(this).width() && $(this).height()) {
                                        return false;
                                    }

                                    $(this).css("width", "");
                                    $(this).css("height", "");

                                    // explicitly set a width and height to the action buttons placeholder, so that when its inner container turned "absolute" positioned,
                                    // it will not shrink/collapse and still retain its width and height.
                                    $(this).width($(".datatable-action-buttons-container", this).width());
                                    $(this).height($(".datatable-action-buttons-container", this).height());
                                });

                                $visibleTable.DataTable().columns.adjust();
                            }
                        }, 100);

                        return false;
                    }
                });
            });
        },
        getPageSize: function () {
            let pageSize = window.localStorage.getItem("dataTable-pageSize");
            if (pageSize) {
                pageSize = parseInt(pageSize, 10);
                if (isNaN(pageSize)) {
                    pageSize = app.consts.grid.defaultPageSize;
                }
            } else {
                pageSize = app.consts.grid.defaultPageSize;
            }

            return pageSize;
        },
        setPageSize: function (pageSize) {
            window.localStorage.setItem("dataTable-pageSize", pageSize);
        }
    };

    // #region app.init

    app.init = function (container) {
        app.init.dataTables(container);
        app.init.dropdowns(container);
        app.init.dateTimePickers(container);
        app.init.numberPickers(container);
        app.init.durationPickers(container);
        app.init.telInputs(container);
        app.init.misc(container);
    };

    app.init.dataTables = app.dataTables.init;

    app.init.dropdowns = function (container = "body") {
        $("select.selectize", container).selectize();
    };

    app.init.dateTimePickers = function (container = "body") {
        $('.tempus-dominus[data-td-custom-type="date-picker"]', container).each(function () {
            const $this = $(this);

            const restrictions = {};

            if ($this.data("min-year")) {
                restrictions.minDate = new Date(parseInt($this.data("min-year"), 10), 0, 1);
            }

            if ($this.data("max-year")) {
                restrictions.maxDate = new Date(parseInt($this.data("max-year"), 10), 11, 31);
            }

            const options = {
                display: {
                    components: {
                        clock: false
                    },
                    buttons: {
                        today: true,
                        clear: true
                    }
                },
                localization: {
                    dayViewHeaderFormat: {
                        month: "long",
                        year: "numeric"
                    },
                    format: window.tempusDominus.DefaultOptions.localization.dateFormats.L
                },
                useCurrent: false
            };

            if (!_.isEmpty(restrictions)) {
                options.restrictions = restrictions;
            }

            $(this).tempusDominus(options);
        });

        $('.tempus-dominus[data-td-custom-type="time-picker"]', container).tempusDominus({
            display: {
                components: {
                    calendar: false,
                    date: false
                },
                buttons: {
                    today: true,
                    clear: true
                }
            },
            localization: {
                dayViewHeaderFormat: {
                    month: "long",
                    year: "numeric"
                },
                format: window.tempusDominus.DefaultOptions.localization.dateFormats.LT,
                hourCycle: abp.dateTimeFormatter.shortTimeFormat.indexOf("H") !== -1 ? "h23" : "h12"
            },
            useCurrent: false
        });

        $('.tempus-dominus[data-td-custom-type="datetime-picker"]', container).each(function () {
            const $this = $(this);

            const restrictions = {};

            if ($this.data("min-year")) {
                restrictions.minDate = new Date(parseInt($this.data("min-year"), 10), 0, 1);
            }

            if ($this.data("max-year")) {
                restrictions.maxDate = new Date(parseInt($this.data("max-year"), 10), 11, 31);
            }

            const options = {
                display: {
                    buttons: {
                        today: true,
                        clear: true
                    }
                },
                localization: {
                    dayViewHeaderFormat: {
                        month: "long",
                        year: "numeric"
                    },
                    format: `${window.tempusDominus.DefaultOptions.localization.dateFormats.L} ${window.tempusDominus.DefaultOptions.localization.dateFormats.LT}`,
                    hourCycle: abp.dateTimeFormatter.shortTimeFormat.indexOf("H") !== -1 ? "h23" : "h12"
                },
                useCurrent: false
            };

            if (!_.isEmpty(restrictions)) {
                options.restrictions = restrictions;
            }

            $(this).tempusDominus(options);
        });

        $('.tempus-dominus[data-td-custom-type="year-picker"]', container).each(function () {
            const $this = $(this);

            const restrictions = {};

            if ($this.data("min-year")) {
                restrictions.minDate = new Date(parseInt($this.data("min-year"), 10), 0, 1);
            }

            if ($this.data("max-year")) {
                restrictions.maxDate = new Date(parseInt($this.data("max-year"), 10), 11, 31);
            }

            const options = {
                display: {
                    components: {
                        clock: false,
                        date: false,
                        month: false,
                        year: true
                    },
                    buttons: {
                        today: true,
                        clear: true
                    }
                },
                localization: {
                    dayViewHeaderFormat: {
                        month: "long",
                        year: "numeric",
                    },
                    format: "YYYY",
                },
                useCurrent: false
            };

            if (!_.isEmpty(restrictions)) {
                options.restrictions = restrictions;
            }

            $(this).tempusDominus(options);
        });

        $('.tempus-dominus[data-td-custom-type="month-picker"]', container).each(function () {
            const $this = $(this);

            const restrictions = {};

            if ($this.data("min-year")) {
                restrictions.minDate = new Date(parseInt($this.data("min-year"), 10), 0, 1);
            }

            if ($this.data("max-year")) {
                restrictions.maxDate = new Date(parseInt($this.data("max-year"), 10), 11, 31);
            }

            const options = {
                display: {
                    components: {
                        calendar: true,   // Required for visual picker
                        clock: false,     // No time
                        date: false,      // No day
                        month: true,      // Show month picker
                        year: true        // Needed so you can select a year + month
                    },
                    buttons: {
                        today: true,
                        clear: true
                    }
                },
                localization: {
                    format: "YYYY-MM"    // Example: 2025-06
                },
                useCurrent: false
            };

            if (!_.isEmpty(restrictions)) {
                options.restrictions = restrictions;
            }

            $(this).tempusDominus(options);
        });
    };

    // modified from the default I18nEditor editor
    const numberPickerEditor = function (props, element) {
        var locale = props.locale || "en-US";

        this.parse = function (customFormat) {
            const numberFormat = new Intl.NumberFormat(locale);
            const thousandSeparator = numberFormat.format(11111).replace(/1/g, "") || ".";
            const decimalSeparator = numberFormat.format(1.1).replace(/1/g, "");
            return parseFloat(customFormat
                .replace(new RegExp(" ", "g"), "")
                .replace(new RegExp(`\\${thousandSeparator}`, "g"), "")
                .replace(new RegExp(`\\${decimalSeparator}`), "."));
        };

        this.render = function (number) {
            const digitGrouping = !(element.getAttribute("data-digit-grouping") === "false");

            const options = {
                useGrouping: digitGrouping
            };

            if (element.hasAttribute("data-decimals") && element.getAttribute("data-decimals") !== null && element.getAttribute("data-decimals") !== "null") {
                const decimals = parseInt(element.getAttribute("data-decimals")) || 0;
                options.minimumFractionDigits = decimals;
                options.maximumFractionDigits = decimals;
            }

            const numberFormat = new Intl.NumberFormat(locale, options);
            return numberFormat.format(number);
        };
    };
    app.init.numberPickers = function (container = "body") {
        const $inputSpinners = $(':not(.input-spinner-container) input.input-spinner', container).each(function () {
            const type = $(this).attr("type");
            $(this).inputSpinner({
                groupClass: "input-spinner-container",
                buttonsClass: "btn-sm btn-secondary",
                editor: numberPickerEditor,
                locale: abp.numberFormatter.getNumberCulture(),
                template: ` <div class="input-group \${groupClass}">
                                <div class="input-group-prepend"></div>
                                <input type="${type == "number" ? "text" : type}" inputmode="decimal" class="form-control" />
                                <div class="input-group-append">
                                    <button class="btn btn-decrement \${buttonsClass}" type="button" tabindex="-1">\${decrementButton}</button>
                                    <button class="btn btn-increment \${buttonsClass}" type="button" tabindex="-1">\${incrementButton}</button>
                                </div>
                            </div>`
            });
        });

        const $inputSpinnerGroups = $inputSpinners.next(".input-spinner-container");
        const $inputSpinnerPrependGroups = $(".input-group-prepend", $inputSpinnerGroups);
        $inputSpinnerPrependGroups.each(function () {
            if ($(this).is(":empty")) {
                $(this).remove();
            }
        });
    };

    app.init.durationPickers = function (container = "body") {
        const $durationContainers = $(".duration-container", container);
        $durationContainers.each(function () {
            const durationContainer = this;

            $('input[type="number"].duration-hour', durationContainer).on("change", function (e) {
                const $durationHourPicker = $(e.target);
                const $durationMinutePicker = $("input.duration-minute", durationContainer);

                let minutesValue = $durationMinutePicker.val();
                if (!minutesValue) {
                    minutesValue = 0;
                    $durationMinutePicker.val(0);
                } else {
                    minutesValue = parseFloat(minutesValue);
                }


                let value = $durationHourPicker.val();
                if (!value) {
                    value = 0;
                    $durationHourPicker.val(value);
                } else {
                    value = parseFloat(value);
                    const floorValue = Math.floor(value);
                    const diff = value - floorValue;

                    if (diff > 0) {
                        $durationHourPicker.val(floorValue);

                        minutesValue += diff * 60;

                        $durationMinutePicker.val(minutesValue);

                        $durationMinutePicker.trigger("change");
                    }
                }

                const duration = `${$durationHourPicker.val().padStart(2, "0")}:${$durationMinutePicker.val().padStart(2, "0")}:00`;
                $('input.duration-input', durationContainer).val(duration);

                const validator = $durationHourPicker.closest("form").data("validator");
                if (validator) {
                    $durationHourPicker.valid();
                    $durationMinutePicker.valid();
                }
            });

            $('input[type="number"].duration-minute', durationContainer).on("change", function (e) {
                const $durationHourPicker = $("input.duration-hour", durationContainer);
                const $durationMinutePicker = $(e.target);

                let hoursValue = $durationHourPicker.val();
                if (!hoursValue) {
                    hoursValue = 0;
                    $durationHourPicker.val(0);
                } else {
                    hoursValue = parseFloat(hoursValue);
                }


                let value = $durationMinutePicker.val();

                if (!value) {
                    value = 0;
                    $durationMinutePicker.val(value);
                } else {
                    value = parseFloat(value);
                    let roundValue = Math.round(value);

                    if (roundValue >= 60) {
                        const q = Math.floor(roundValue / 60);
                        const r = roundValue % 60;
                        roundValue = r;

                        hoursValue += q;
                        $durationHourPicker.val(hoursValue);
                    }

                    $durationMinutePicker.val(roundValue);
                }

                const duration = `${$durationHourPicker.val().padStart(2, "0")}:${$durationMinutePicker.val().padStart(2, "0")}:00`;
                $('input.duration-input', durationContainer).val(duration);

                const validator = $durationHourPicker.closest("form").data("validator");
                if (validator) {
                    validator.element($durationHourPicker);
                    validator.element($durationMinutePicker);
                }
            });
        });
    };

    app.init.telInputs = function (container = "body") {
        $('input.input-tel[type="tel"]', container).intlTelInput();
    };

    app.init.misc = function (container = "body") {
        // Brings all hidden inputs from the bottom of a form to the top of the form.
        // Reason:
        // Last element with class "form-group" will not add a margin-bottom.
        // If there's a hidden input after the element with class "form-group", that makes the element not being the last child anymore and will add an undesirable margin-bottom
        // which act as a spacing between it and the hidden input. Since the hidden input is not visible anyway, the space is redundant and unappealing.
        $("form", container).each(function () {
            const $form = $(this);

            let continueLooping = true;
            while (continueLooping) {
                const $lastElement = $form.children(":last-child");
                if ($lastElement.is('input[type="hidden"]')) {
                    $form.prepend($lastElement);
                } else {
                    continueLooping = false;
                }
            }
        });

        // Metronic switch
        $('.switch[data-color-set] input[type="checkbox"]', container).refreshMetronicSwitch();
    };

    // #endregion

    // #region app.destroy

    app.destroy = function (container = "body") {
        $("form", container).each(function () {
            const validator = $(this).data("validator");
            if (validator) {
                validator.destroy();
            }
        });

        app.destroy.dataTables(container);
        app.destroy.dropdowns(container);
        app.destroy.dateTimePickers(container);
        app.destroy.numberPickers(container);
        app.destroy.telInputs(container);
        app.destroy.misc(container);
    }
    app.destroy.dataTables = app.dataTables.destroy;
    app.destroy.dropdowns = function (container = "body") {
        $("select.selectize.selectized", container).each(function () {
            this.selectize.destroy();
        });
    };
    app.destroy.dateTimePickers = function (container = "body") {
        $(".tempus-dominus", container).each(function () {
            const td = $(this).data(window.tempusDominus.Namespace.dataKey);
            if (td) {
                td.dispose();
            }
        });
    };
    app.destroy.numberPickers = function (container = "body") {
        $('input.input-spinner[type="number"]', container).inputSpinner("destroy");
    };
    app.destroy.telInputs = function (container = "body") {
        var results = $('input.input-tel[type="tel"]', container).intlTelInput();
        if (results) {
            if (_.isArray(results)) {
                _.each(results, function (iti) {
                    iti.destroy();
                });
            } else {
                results.destroy();
            }
        }
    };
    app.destroy.misc = function (container = "body") {

    };

    // #endregion

    app.showLoader = app.showLoader || function (showLoaderOnNextLoad, callback) {
        if (showLoaderOnNextLoad) {
            sessionStorage.setItem("pageLoader", true);
        }

        const loaderSpinner = document.getElementById("loader_spinner");
        const loaderLogo = document.getElementById("loader_logo");

        const loader = new SVGLoader(document.getElementById("loader"), { speedIn: 400, speedOut: 400, easingIn: window.mina.easeinout });

        loader.show(function () {
            const showLogoCallback = function () {
                loaderLogo.removeEventListener("animationend", showLogoCallback);
                if (callback) {
                    callback();
                }
            };

            loaderSpinner.classList.add("show");

            loaderLogo.addEventListener("animationend", showLogoCallback);
            loaderLogo.classList.add("show");
        });
    };

    app.isValidUrl = function (stringUrl) {
        let url;

        try {
            url = new URL(stringUrl);
        } catch (_) {
            return false;
        }

        return url.protocol === "http:" || url.protocol === "https:";
    };

    app.redirectToLockScreen = function () {
        abp.ajax({
            contentType: app.consts.contentTypes.formUrlEncoded,
            url: `${abp.appPath}Account/LockSession`,
            data: {
                returnUrl: window.location.href.substring(window.location.origin.length)
            },
            abpHandleError: false
        }).fail(function (error) {
            const redirectUri = new window.URI(`${abp.appPath}Account/SessionLockScreen`)
                .search({
                    returnUrl: window.location.href.substring(window.location.origin.length)
                });
            window.location.replace(redirectUri.toString());
        });
    };

    app.redirectToLogout = function () {
        const redirectUri = new window.URI(`${abp.appPath}Account/Logout`)
            .search({
                returnUrl: window.location.href.substring(window.location.origin.length)
            });
        window.location.replace(redirectUri.toString());
    };

    app.throttle = function (interval, callback) {
        let enableCall = true;

        return function (...args) {
            if (!enableCall) return;

            enableCall = false;
            callback.apply(this, args);
            setTimeout(() => enableCall = true, interval);
        };
    };

    app.camelizeKeys = (obj, excludedKeys) => {
        if (!_.isObject(obj)) {
            return obj;
        } else if (_.isArray(obj)) {
            return obj.map((v) => app.camelizeKeys(v));
        }
        return _.reduce(obj, (r, v, k) => {
            return {
                ...r,
                [excludedKeys && _.includes(excludedKeys, k) ? k : _.camelCase(k)]: app.camelizeKeys(v)
            };
        }, {});
    };

    app.pascalCase = str => _.startCase(_.camelCase(str)).replace(/ /g, "");

    app.convertMemberNameToInputName = function (memberName) {
        let result = "";

        const parts = _.split(memberName, ".");
        _.each(parts, function (part, index) {
            result += `${(index > 0 ? "[" : "")}${_.upperFirst(part)}${(index > 0 ? "]" : "")}`;
        });

        return result;
    };

    app.isOverlayShown = function () {
        return $(".modal.show").length > 0 || $(".offcanvas-overlay").length > 0;
    };

    app.grabAttention = function (element) {
        $(element)
            .one("animationend", function () {
                $(this).removeClass("animate__animated animate__heartBeat");
            })
            .addClass("animate__animated animate__heartBeat");
    };

    app.setBitwiseCheckboxesToValues = function (valueObject, container = "body") {
        $(".bitwise-boolean-container", container).each(function () {
            $('[data-value-type="bitwiseBoolean"]', this).each(function () {
                const $inputCheckbox = $(this);

                const defaultValue = parseInt(valueObject[_.camelCase($inputCheckbox.attr("name"))], 10);
                const value = parseInt($inputCheckbox.val(), 10);

                if (defaultValue & value) {
                    $inputCheckbox.prop("checked", true);
                } else {
                    $inputCheckbox.prop("checked", false);
                }
            });
        });
    };

    app.switchBootstrapTab = function (tab, callback, stopIfDisabled = false, preventFocusFirstElement = false) {
        const $tab = $(tab);
        if ($tab.hasClass("disabled") && stopIfDisabled) {
            return;
        }

        if (preventFocusFirstElement) {
            // there are times when we want to prevent the first element in the tab content from receiving focus,
            // for example when a form failed validation and we want to focus on the element that fails validation instead of the first element.
            app.preventFocusFirstElement(true);
        }

        if ($tab.hasClass("disabled")) {
            // if the tab is disabled (in the case of creation of new employee), enable it.
            $tab.removeClass("disabled");
        }
        if ($tab.hasClass("active")) {
            // if the tab is already shown, showing it again won't trigger the "shown" event, need to manually trigger it
            if (callback) {
                callback.call(tab);
            }

            if (preventFocusFirstElement) {
                app.preventFocusFirstElement(false);
            }
        } else {
            // if the tab is not already shown, show it
            if (callback) {
                $tab.one("shown.bs.tab", function () {
                    callback.call(tab);
                });
            }
            $tab.tab("show");
        }
    };

    app.triggerEntityStatusChangedCallback = function (dto, data) {
        setTimeout(function () {
            abp.event.trigger("app.entityStatusChanged", $.extend({}, dto, data));
        });
    };

    app.modal = app.modal || {};
    app.modal.createScrollTopElement = function (modal) {
        if ($(".modal-scrolltop", modal).length === 0) {
            $(".modal-content", modal).append(`<div class="modal-scrolltop">
                                                        <div class="scrolltop">
                                                            <i class="fa fa-arrow-up"></i>
                                                        </div>
                                                    </div>`);
        }
    };

    app.modal.afterSaved = function (modalManager, e, context) {
        setTimeout(function () {
            if (!e.alternateSave) {
                modalManager.close();
                return;
            }

            if (context) {
                const router = modalManager.routing?.router;

                if (router) {
                    const uri = new window.URI();
                    const search = uri.search(true);

                    switch (e.alternateSave) {
                        case app.consts.alternateSaveType.saveAndEdit:
                            if (context.args && context.args[modalManager.routing.argIdPropertyName]) {
                                search[modalManager.routing.queryStringIdPropertyName] = context.args[modalManager.routing.argIdPropertyName];

                                uri.search(search);

                                router.set(router.config.location.pathname, {
                                    queryString: uri.query(),
                                    replace: true,
                                    preventDefault: true
                                });
                            }
                            break;

                        case app.consts.alternateSaveType.saveAndCreate:
                            context.args = context.args || {};
                            delete context.args[modalManager.routing.argIdPropertyName];
                            search[modalManager.routing.queryStringIdPropertyName] = 0;

                            uri.search(search);

                            router.set(router.config.location.pathname, {
                                queryString: uri.query(),
                                replace: true,
                                preventDefault: true
                            });
                            break;
                    }
                }

                if (context.options && !_.isEmpty(context.options)) {
                    modalManager.setOptions($.extend(modalManager.getOptions(), context.options));
                }
                modalManager.setArgs(context.args);
            }
            modalManager.reset();
        });
    };

    app.modal.triggerEntityStatusChangedCallback = function (dto, data) {
        app.triggerEntityStatusChangedCallback(dto, data);

        this.reset();
    };

    /**
     * @callback subscriptionCallback
     * @this {ModalManager} - The instance of ModalManager which is to be returned from {@link app.modal.createModalWithRouting}
     * @param {Object} router - The router object of SilkRouter.
     * @param {string} value - The value of the query string with the key {@link configuration.queryStringIdPropertyName}.
     * @param {Object} search - The object that contains all the query string key value pairs.
     */
    /**
     * @callback subscribeCondition
     * @this {ModalManager} - The instance of ModalManager which is to be returned from {@link app.modal.createModalWithRouting}
     * @param {Object} router - The router object of SilkRouter.
     * @param {Object} search - The object that contains all the query string key value pairs.
     */
    /**
     * @callback onEventCallback
     * @this {ModalManager} - The instance of ModalManager which is to be returned from {@link app.modal.createModalWithRouting}
     * @param {Object} router - The router object of SilkRouter.
     * @param {string} value - The value of the id argument passed into ModalManager when its Modal is opened.
     * @param {Object} search - The object that contains all the query string key value pairs.
     */
    /**
     * @callback onErrorCallback
     * @this {ModalManager} - The instance of ModalManager which is to be returned from {@link app.modal.createModalWithRouting}
     * @param {Object} router - The router object of SilkRouter.
     * @param {string} value - The value of the id argument passed into ModalManager when its Modal is opened.
     * @param {Object} search - The object that contains all the query string key value pairs.
     * @param {Object} jqXHR - jQuery's jqXHR object.
     * @param {string} textStatus - Possible values (besides null) are "timeout", "error", "abort", and "parsererror".
     * @param {string} errorThrown - When an HTTP error occurs, errorThrown receives the textual portion of the HTTP status, such as "Not Found" or "Internal Server Error." (in HTTP/2 it may instead be an empty string).
     */
    /**
     * @callback onCloseCallback
     * @this {ModalManager} - The instance of ModalManager which is to be returned from {@link app.modal.createModalWithRouting}
     * @param {Object} router - The router object of SilkRouter.
     * @param {Object} search - The object that contains all the query string key value pairs.
     */
    /**
     * @description Creates an instance of ModalManager and wire it up with routing capability
     * @param {Object} configuration - The configuration object to control the behaviour of the ModalManager with routing to be created.
     * @param {Object} configuration.options - The options object of the ModalManager to be created.
     * @param {Object} configuration.router - The router object of SilkRouter.
     * @param {subscriptionCallback} configuration.subscriptionCallback - The callback that is executed when the url contains the query string key {@link configuration.queryStringIdPropertyName}.
     * @param {boolean|subscribeCondition} configuration.subscribeCondition - The condition when the {@link configuration.subscriptionCallback} is executed.
     * @param {string} [configuration.queryStringIdPropertyName=id] - The query string key to append/remove to/from the url when the Modal of the ModalManager is opened.
     * @param {string} [configuration.argIdPropertyName=id] - The property name of the argument passed into ModalManager when its Modal is opened. Generally this is the id.
     * @param {onEventCallback} configuration.onShown - The callback that is executed when the ModalManager has its Modal showing.
     * @param {onEventCallback} configuration.onShown - The callback that is executed when the ModalManager has its Modal shown.
     * @param {onEventCallback} configuration.onLoaded - The callback that is executed when the ModalManager has its Modal loading (when opening and refreshing).
     * @param {onEventCallback} configuration.onLoaded - The callback that is executed when the ModalManager has its Modal loaded (when opened and refreshed).
     * @param {onEventCallback} configuration.onUnloading - The callback that is executed when the ModalManager has its Modal unloading (when closing and refreshing).
     * @param {onEventCallback} configuration.onUnloaded - The callback that is executed when the ModalManager has its Modal unloaded (when closed and refreshed).
     * @param {onErrorCallback} configuration.onError - The callback that is executed when an error occurred during opening of ModalManager.
     * @param {onCloseCallback} configuration.onClosing - The callback that is executed when the ModalManager has its Modal closing.
     * @param {onCloseCallback} configuration.onClosed - The callback that is executed when the ModalManager has its Modal closed.
     * @returns {ModalManager} - An instance of ModalManager.
     */
    app.modal.createModalWithRouting = function (configuration) {
        const modalManager = new app.ModalManager(configuration.options);

        if (!configuration.queryStringIdPropertyName) {
            configuration.queryStringIdPropertyName = "id";
        }

        if (!configuration.argIdPropertyName) {
            configuration.argIdPropertyName = "id";
        }

        if (configuration.router) {
            if (configuration.onShowing) {
                modalManager.onShowing(function () {
                    const argId = this.getArgs()[configuration.argIdPropertyName];

                    const uri = new window.URI();
                    const search = uri.search(true);

                    search[configuration.queryStringIdPropertyName] = argId ? argId : 0;
                    configuration.onShowing.call(this, configuration.router, argId, search);
                });
            }

            modalManager.onShown(function () {
                // #region Set router path
                const argId = this.getArgs()[configuration.argIdPropertyName];

                const uri = new window.URI();
                const search = uri.search(true);

                search[configuration.queryStringIdPropertyName] = argId ? argId : 0;
                configuration.onShown?.call(this, configuration.router, argId, search);

                uri.search(search);

                configuration.router.set(configuration.router.config.location.pathname, {
                    queryString: uri.query(),
                    replace: true,
                    preventDefault: true
                });
                // #endregion
            });

            if (configuration.onLoading) {
                modalManager.onLoading(function () {
                    const argId = this.getArgs()[configuration.argIdPropertyName];

                    const uri = new window.URI();
                    const search = uri.search(true);

                    search[configuration.queryStringIdPropertyName] = argId ? argId : 0;
                    configuration.onLoading.call(this, configuration.router, argId, search);
                });
            }

            if (configuration.onLoaded) {
                modalManager.onLoaded(function () {
                    const argId = this.getArgs()[configuration.argIdPropertyName];

                    const uri = new window.URI();
                    const search = uri.search(true);

                    search[configuration.queryStringIdPropertyName] = argId ? argId : 0;
                    configuration.onLoaded.call(this, configuration.router, argId, search);
                });
            }

            if (configuration.onUnloading) {
                modalManager.onUnloading(function () {
                    const argId = this.getArgs()[configuration.argIdPropertyName];

                    const uri = new window.URI();
                    const search = uri.search(true);

                    search[configuration.queryStringIdPropertyName] = argId ? argId : 0;
                    configuration.onUnloading.call(this, configuration.router, argId, search);
                });
            }

            if (configuration.onUnloaded) {
                modalManager.onUnloaded(function () {
                    const argId = this.getArgs()[configuration.argIdPropertyName];

                    const uri = new window.URI();
                    const search = uri.search(true);

                    search[configuration.queryStringIdPropertyName] = argId ? argId : 0;
                    configuration.onUnloaded.call(this, configuration.router, argId, search);
                });
            }

            if (configuration.onError) {
                modalManager.onError(function (jqXHR, textStatus, errorThrown) {
                    const argId = this.getArgs()[configuration.argIdPropertyName];

                    const uri = new window.URI();
                    const search = uri.search(true);

                    search[configuration.queryStringIdPropertyName] = argId ? argId : 0;
                    configuration.onError.call(this, configuration.router, argId, search, jqXHR, textStatus, errorThrown);
                });
            }

            if (configuration.onClosing) {
                modalManager.onClosing(function () {
                    const uri = new window.URI();
                    const search = uri.search(true);

                    delete search[configuration.queryStringIdPropertyName];
                    configuration.onClosing.call(this, configuration.router, search);
                });
            }

            modalManager.onClosed(function () {
                // #region Set router path
                const uri = new window.URI();
                const search = uri.search(true);

                delete search[configuration.queryStringIdPropertyName];
                configuration.onClosed?.call(this, configuration.router, search);

                uri.search(search);

                configuration.router.set(configuration.router.config.location.pathname, {
                    queryString: uri.query(),
                    replace: true,
                    preventDefault: true
                });
                // #endregion
            });

            modalManager.routing = {
                router: configuration.router,
                queryStringIdPropertyName: configuration.queryStringIdPropertyName,
                argIdPropertyName: configuration.argIdPropertyName
            };

            if (configuration.subscriptionCallback) {
                const uri = new window.URI(configuration.router.config.location.href);
                const search = uri.search(true);

                if (configuration.subscribeCondition == null || configuration.subscribeCondition == undefined || (typeof (configuration.subscribeCondition) == "boolean" && configuration.subscribeCondition) || (typeof (configuration.subscribeCondition) == "function" && configuration.subscribeCondition.call(modalManager, configuration.router, search))) {
                    const subscription = configuration.router.subscribe(e => {
                        const uri = new window.URI(e.router.config.location.href);
                        const search = uri.search(true);

                        if (_.has(search, configuration.queryStringIdPropertyName)) {
                            setTimeout(function () {
                                configuration.subscriptionCallback?.call(modalManager, configuration.router, search[configuration.queryStringIdPropertyName], search);
                            });
                        }
                    });

                    modalManager.routing.subscriptions = {
                        main: subscription
                    };
                }
            }
        }

        return modalManager;
    };

    app.kendo = app.kendo || {};
    app.kendo.postInit = function (container = "body") {
        // numeric text box
        var $elements;
        if (container) {
            $elements = $('[data-role="numerictextbox"]', $(container));
        } else {
            $elements = $('[data-role="numerictextbox"]');
        }

        $elements.each(function () {
            const id = $(this).attr("id");
            const $inputDisplay = $(this).prev("input.k-input");
            if ($inputDisplay.length) {
                const $inputDisplayId = id + "_input";

                $inputDisplay.attr("id", $inputDisplayId);

                $(`label[for="${id}"]`).attr("for", $inputDisplayId);
            }

            $(this).data("kendoNumericTextBox").options.selectOnFocus = true;
        });
    };
})(jQuery);
